import React, { useState } from "react";

/* ============================================================
   GUEST IDENTITY FORM
   Renders inline inside the chat conversation area.
   Collects Full Name, Email, and Mobile before allowing chat.
   ============================================================ */

const GuestIdentityForm = ({ onSubmit }) => {
  const [fields, setFields] = useState({ name: "", email: "", mobile: "" });
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  const validate = () => {
    const errs = {};
    const name = fields.name.trim();
    const email = fields.email.trim();
    const mobile = fields.mobile.trim();

    if (!name || name.length < 2) {
      errs.name = "Full name must be at least 2 characters.";
    }
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errs.email = "Please enter a valid email address.";
    }
    if (!mobile || !/^\d{10,}$/.test(mobile.replace(/[\s\-\+\(\)]/g, ""))) {
      errs.mobile = "Mobile number must be at least 10 digits.";
    }
    return errs;
  };

  const handleChange = (field) => (e) => {
    setFields((prev) => ({ ...prev, [field]: e.target.value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setSubmitting(true);
    onSubmit({
      name: fields.name.trim(),
      email: fields.email.trim(),
      mobile: fields.mobile.trim(),
    });
  };

  return (
    <div className="gai-guest-form-wrap">
      <form onSubmit={handleSubmit} noValidate>
        {/* Name */}
        <div className="gai-guest-field">
          <label className="gai-guest-label" htmlFor="guest-name">
            Full Name
          </label>
          <input
            id="guest-name"
            type="text"
            className={`gai-guest-input${errors.name ? " gai-guest-input--error" : ""}`}
            placeholder="e.g. Aisha Khan"
            value={fields.name}
            onChange={handleChange("name")}
            disabled={submitting}
            autoComplete="name"
          />
          {errors.name && (
            <span className="gai-guest-error">{errors.name}</span>
          )}
        </div>

        {/* Email */}
        <div className="gai-guest-field">
          <label className="gai-guest-label" htmlFor="guest-email">
            Email
          </label>
          <input
            id="guest-email"
            type="email"
            className={`gai-guest-input${errors.email ? " gai-guest-input--error" : ""}`}
            placeholder="e.g. aisha@company.com"
            value={fields.email}
            onChange={handleChange("email")}
            disabled={submitting}
            autoComplete="email"
          />
          {errors.email && (
            <span className="gai-guest-error">{errors.email}</span>
          )}
        </div>

        {/* Mobile */}
        <div className="gai-guest-field">
          <label className="gai-guest-label" htmlFor="guest-mobile">
            Mobile No.
          </label>
          <input
            id="guest-mobile"
            type="tel"
            className={`gai-guest-input${errors.mobile ? " gai-guest-input--error" : ""}`}
            placeholder="e.g. 9876543210"
            value={fields.mobile}
            onChange={handleChange("mobile")}
            disabled={submitting}
            autoComplete="tel"
          />
          {errors.mobile && (
            <span className="gai-guest-error">{errors.mobile}</span>
          )}
        </div>

        <button
          type="submit"
          className="gai-guest-submit"
          disabled={submitting}
        >
          {submitting ? "Starting…" : "Start Chatting"}
        </button>
      </form>
    </div>
  );
};

export default GuestIdentityForm;
